// extracted by mini-css-extract-plugin
export var divider = "_yk-0";